import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
var _createContextStore = createContextStore({
    email: "",
    companyName: "",
    url: "",
    secondaryCategoryOptions: new Set(),
    country: null,
    formErrors: {},
    apiErrors: {},
    urlValidationInProgress: false,
    temporaryPosLinkKey: undefined,
    brandLeadToken: null,
    brandLeadCreationFailure: false
}, {
    name: "MakerSignUpFormStore"
}), useMakerSignUpFormContextStore = _createContextStore.useStore, MakerSignUpFormContextStoreProvider = _createContextStore.Provider;
export { useMakerSignUpFormContextStore, MakerSignUpFormContextStoreProvider };
